import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../context/DataContext";
import supabase from "../supabase/supabaseClient";
import Usuarios from "../components/Usuarios";

import estilo from "./styles/Inicio.module.css";
import { usePageVisibility } from "react-page-visibility";
import DatosUsuario from "../components/DatosUsuario";

function Inicio() {
  const { usuario, url, click } = useContext(DataContext);

  const [informacion, setInformacion] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [cantidadUsuarios, setCantidadUsuarios] = useState(1);
  const [activar, setActivar] = useState(false);
  const [sexo, setSexo] = useState("");
  const [activarSexo, setActivarSexo] = useState(null);

  //controlador
  const isVisible = usePageVisibility();

  React.useEffect(() => {
    if (isVisible) {
      console.log(true);
      actualizarEstado(true);
    } else {
      console.log(false);
      actualizarEstado(false);
    }
  }, [isVisible]);

  async function actualizarEstado(conectado) {
    await supabase
      .from("usuarios_chat")
      .update({ estado: conectado })
      .eq("user_id", usuario.id);
  }

  //traer usuarios
  useEffect(() => {
    const fetchUsuarios = async () => {
      if (activarSexo === false) {
        if (sexo === "Ambos") {
          const { data, error } = await supabase.from("usuarios_chat").select();

          if (data) {
            //filtramos usuario principal para no traerlo
            setUsuarios(
              data
                .sort(() => Math.random() - 0.5)
                .filter((e) => e.user_id !== usuario.id)
            );
            setCantidadUsuarios(data.length - 1);
            setActivarSexo(false);
          }
        } else {
          const { data, error } = await supabase
            .from("usuarios_chat")
            .select()
            .eq("sexo", sexo);

          if (data) {
            //filtramos usuario principal para no traerlo
            setUsuarios(
              data
                .sort(() => Math.random() - 0.5)
                .filter((e) => e.user_id !== usuario.id)
            );
            setCantidadUsuarios(data.length - 1);
            setActivarSexo(false);
          }
          if (error) {
            console.log(error);
          }
        }
      }
    };

    fetchUsuarios();
  }, [activar, sexo]);

  //escuchar cambio de una tabla
  useEffect(() => {
    const realTime = async () => {
      supabase
        .channel("any")
        .on(
          "postgres_changes",
          { event: "INSERT", schema: "public", table: "usuarios_chat" },
          (payload) => {
            console.log(payload.errors);
            setActivar(true);
          }
        )

        .subscribe();
      setActivar(false);
    };

    realTime();
  }, []);

  //comprobar si existe en tabla y extraer personas contactos (todos las agregados)
  const [contactosLista, setContactosLista] = useState([]);

  useEffect(() => {
    const fetchUsuario = async () => {
      const { data, error } = await supabase
        .from("usuarios_chat")
        .select()
        .eq("user_id", usuario.id);

      if (data) {
        setInformacion(data.filter((e) => e.user_id === usuario.id)[0]);
        setContactosLista(data.contactos);
        if (data.length > 0) {
          setSexo(data[0].sexo_filtro);
          if (data[0].sexo_filtro === null) {
            setActivarSexo(true);
          } else {
            setActivarSexo(false);
          }
        }
      }
      if (error) {
        console.log(error);
        setActivar(false);
      }
    };

    fetchUsuario();
  }, [click]);

  const [numeroInicial, setNumeroInicial] = useState(0);
  const [numeroFinal, setNumeroFinal] = useState(1);

  //actualizar dependiendo si estas o no conectado
  // useEffect(() => {
  //   const updateUserStatus = async () => {
  //     // Esta función actualiza el estado del usuario en la base de datos
  //     const updateUserStatusInDB = async (conectado) => {
  //       await supabase
  //         .from("usuarios_chat")
  //         .update({ estado: conectado })
  //         .eq("user_id", usuario.id);
  //     };

  //     // Esta función actualiza el estado del usuario a "conectado"
  //     const setConectado = async () => {
  //       await updateUserStatusInDB(true);
  //     };

  //     // Esta función actualiza el estado del usuario a "desconectado"
  //     const setDesconectado = async () => {
  //       await updateUserStatusInDB(false);
  //     };

  //     // Esta función se llama cuando el usuario cambia de pestaña o minimiza la ventana
  //     const handleVisibilityChange = async () => {
  //       if (document.visibilityState === "visible") {
  //         await setConectado();
  //       } else {
  //         await setDesconectado();
  //       }
  //     };

  //     // Esta función se llama cuando el usuario cambia de pestaña o minimiza la ventana
  //     const handlePageHide = async () => {
  //       await setDesconectado();
  //     };

  //     // Esta función se llama cuando el usuario cierra el navegador
  //     const handleUnload = async () => {
  //       await setDesconectado();
  //     };

  //     const handleBeforeUnload = async () => {
  //       await setDesconectado();
  //     };

  //     // Cuando el usuario cambia de pestaña o minimiza la ventana
  //     document.addEventListener("visibilitychange", handleVisibilityChange);
  //     // Cuando el usuario cambia de pestaña o minimiza la ventana
  //     window.addEventListener("pagehide", handlePageHide);
  //     // Cuando el usuario cierra el navegador
  //     window.addEventListener("unload", handleUnload);
  //     window.addEventListener("beforeunload", handleBeforeUnload);

  //     // Cuando la página se carga, marcamos al usuario como conectado
  //     await setConectado();

  //     return async () => {
  //       document.removeEventListener(
  //         "visibilitychange",
  //         handleVisibilityChange
  //       );
  //       window.removeEventListener("pagehide", handlePageHide);
  //       window.removeEventListener("unload", handleUnload);
  //       window.removeEventListener("beforeunload", handleBeforeUnload);
  //       // Cuando la página se cierra, marcamos al usuario como desconectado
  //       await setDesconectado();
  //     };
  //   };

  //   updateUserStatus();
  // }, []);

  //filtrar por sexo
  let filtro = ["Ambos", "Hombre", "Mujer"];

  function filtrarSexo(e) {
    setSexo(e.target.dataset.value);
    actualizarSexoFitlro(e.target.dataset.value);
    setActivarSexo(false);
  }

  async function actualizarSexoFitlro(filtro) {
    await supabase
      .from("usuarios_chat")
      .update({ sexo_filtro: filtro })
      .eq("user_id", usuario.id);
  }

  return (
    <div className={estilo.inicio}>
      {/* {informacion && (
        <div className={estilo.usuario}>
          <div className={estilo.foto}>
            <img
              src={url + informacion.user_id}
              alt={informacion.nombre_usuario}
              width="100px"
              height="100px"
            />
          </div>

          <div className={estilo.datos}>
            <h3>{informacion.nombre_usuario}</h3>

            <div className={estilo.datos_usuario}>
              <p>{informacion.sexo}</p>
              <p>{informacion.edad}</p>
            </div>
          </div>
        </div>
      )} */}

      {usuarios && informacion === undefined ? (
        <DatosUsuario dato={usuario}></DatosUsuario>
      ) : null}

      {informacion && activarSexo ? (
        <div className={estilo.filtro}>
          <h4>¿Qué estas buscando?</h4>
          <div className={estilo.botones}>
            {filtro.map((e, i) => (
              <p
                key={i}
                data-value={e}
                className={sexo === e ? estilo.activo : estilo.no_activo}
                onClick={filtrarSexo}
              >
                {e}
              </p>
            ))}
          </div>
        </div>
      ) : null}

      {usuarios &&
        usuarios.slice(numeroInicial, numeroFinal).map((e) => (
          <div key={e.id} className={estilo.usuarios}>
            <Usuarios
              dato={e}
              cantidad={cantidadUsuarios}
              numI={numeroInicial}
              setNumI={setNumeroInicial}
              numF={numeroFinal}
              setNumF={setNumeroFinal}
            ></Usuarios>
          </div>
        ))}

      {/* <Contactos></Contactos> */}
    </div>
  );
}

export default Inicio;
